const Register = "Register";
const JoinRoomRequested = "JoinRoomRequested";
const LeaveRoomRequested = "LeaveRoomRequested";
const CreateRoom = "CreateRoom";
const JoinRoom = "JoinRoom";
const LeaveRoom = "LeaveRoom";
const Disconnected = "Disconnected";
const Message = "Message";
const RegistrationSuccess = "RegistrationSuccess";
const MessageReceived = "MessageReceived";
const MessageRead = "MessageRead";
const RequestBot = "RequestBot";
const RequestAgent = "RequestAgent";
const AgentAssigned = "AgentAssigned";
const Customer = "customer";
const Agent = "agent";
const Bot = "bot";
const ChatSystem ="chatSystem"
const System = "system";
const RoomClose = "CloseRoom";
const Ping = "Ping";
const MessageUpdate = "MessageUpdate";
const MessageDelete = "MessageDelete";
const QueuedForAssignment = "QueuedForAssignment";
const BotAssigned = "BotAssigned"
const MessageDelivered = "MessageDelivered"
const SetRoomProperties = "SetRoomProperties"
const RemoveBot= "RemoveBot";
const VCButtonVisibility ="VCButtonVisibility";


const CallInitiated = "CallInitiated";
const CallEnded = "CallEnded";
const CallInProcessing = "CallInProcessing";

const Health = 2
const Travel = 3
const Home = 101
const Term = 7
const Investment = 115
const Motor = 117
const Twowheeler = 114
const CommercialVehicle =139

const Text = "text";
const json = "json";
const html = "html";
const document = "document"
const RequestCallback = "RequestCallback";
const Good = "Good";
const Bad = "Bad";

const ChatEvents = {
  Register,
  RegistrationSuccess,
  CreateRoom,
  JoinRoomRequested,
  JoinRoom,
  LeaveRoom,
  Disconnected,
  Message,
  LeaveRoomRequested,
  MessageReceived,
  MessageRead,
  RequestBot,
  RequestAgent,
  AgentAssigned,
  RoomClose,
  Ping,
  MessageUpdate,
  MessageDelete,
  QueuedForAssignment,
  BotAssigned,
  RequestCallback,
  MessageDelivered,
  SetRoomProperties,
  RemoveBot,
  VCButtonVisibility,
};
const WebCalling = {
  CallInitiated,
  CallEnded,
  CallInProcessing
}

const Product = {
  Health,
  Travel,
  Home,
  Term,
  Investment,
  Motor,
  Twowheeler,
  CommercialVehicle
}
const Sources = {
  POST_PAYMENT_CAR_CJ : 'post_payment_car_cj'
}
const ServiceBotProducts = [117];

const Roles = { Customer, Agent , Bot , ChatSystem, System};

const MessageType = { Text, json, html, document }

const CASTOptions = { Good, Bad }

module.exports = { ChatEvents, Roles, MessageType, CASTOptions, Product ,Sources, WebCalling};
